
import ResponsiveTable from "../../../components/ResponsiveTable";
import { hideLoading, showLoading } from "../../../loading";
import swal from 'sweetalert';
import request from "../../../request";
import { IconButton } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Editor from "./Editor";
import { requestConfirmation } from "../../../utils";
import { USER_ROLE } from "../../../../../shared/constants";
import { connect } from "react-redux";
import { hasIntersection } from "../../../../../shared/utils";
import { ConnectEntityToQuickbooks } from "../../../components/ConnectEntityToQuickbooks";
import { Link } from "@mui/icons-material";
import NavigationStateSaver from "../../../components/NavigationStateSaver";
import PillLabel from "../../../components/PillLabel";


class _Products extends NavigationStateSaver {

   state = {
      products: null,
      page: 0,
      pageSize: 10,
      productCount: 0,
      editorOpen: false,
      selectedProduct: null,
      connectQuickbooksModalOpen: false,
   }

   openConnectToQuickbooksModal = (selectedProduct) => {
      this.setState({ connectQuickbooksModalOpen: true, selectedProduct });
   }

   closeConnectToQuickbooksModal = data => {
      const { selectedProduct } = this.state;
      this.setState({ connectQuickbooksModalOpen: false, selectedProduct: null });

      if (data) {
         const products = this.state.products.map(product => {
            if (product._id === selectedProduct._id)
               product = { ...product, ...data };
            return product;
         });

         this.setState({ products });
      }
   }

   openEditor = (selectedProduct = null) => {
      this.setState({ editorOpen: true, selectedProduct });
   }

   closeEditor = (product) => {
      const update = { editorOpen: false, selectedProduct: null };

      if (product) {
         if (this.state.selectedProduct) {
            update.products = this.state.products.map(p => p._id === product._id ? product : p);
         } else {
            update.products = [product, ...this.state.products];
            update.productCount = this.state.productCount + 1;
         }
      }

      this.setState(update);
   }

   deleteProduct = async (product) => {

      // confirm
      const question = `Delete "${product.name}"?`;
      const confirmed = await requestConfirmation(question);

      if (!confirmed) return;

      // delete
      try {

         showLoading();

         const productId = product._id;
         await request.delete(`/api/sales/products/${productId}`);

         const products = this.state.products.filter(product => product._id !== productId);
         const productCount = this.state.productCount - 1;

         this.setState({ products, productCount });

      } catch (err) {
         swal("Error", err.toString(), "error");
      } finally {
         hideLoading();
      }
   }


   fetchProducts = async () => {

      try {

         showLoading();

         const limit = this.state.pageSize;
         const page = this.state.page + 1;
         const params = { page, limit };

         const res = await request.get('/api/general/products', { params });
         const { products, total: productCount } = res.data;

         this.setState({ products, productCount });

      } catch (err) {
         swal("Error", err.toString(), 'error');
      } finally {
         hideLoading();
      }
   }

   async componentDidMount() {
      await super.componentDidMount();
      if (!this.state.products)
         this.fetchProducts();
   }
   
   render() {

      const { roles } = this.props;

      let onAdd;
      if (hasIntersection(roles, [USER_ROLE.SUPER_ADMIN, USER_ROLE.SALES_MANAGER]))
         onAdd = () => this.openEditor();

      return <>
         <ResponsiveTable
            cols={[
               { field: 'name', caption: 'Name' },
               {
                  field: 'type',
                  caption: 'Type',
                  render: type => <PillLabel className="uppercase">{type}</PillLabel>
               },
               {
                  field: 'composition',
                  caption: 'Composition',
                  render: composition => {
                     if (!composition) return null;
                     return <div className="grid grid-cols-[auto,1fr] gap-4 text-gray-600 max-w-[400px]">
                        {
                           composition.map(({ product, quantity}) => {

                              let name, description;
                              if (product) {
                                 name = product.name;
                                 description = product.description;
                              } else {
                                 name = '(Deleted product)';
                              }


                              return <>
                                 <div className="rounded-full bg-gray-400 text-white text-xl font-bold px-2 py-1 aspect-square flex items-center justify-center">
                                    {quantity}
                                 </div>
                                 <div className="flex items-center">
                                    <div>
                                       <div className="text-sm font-bold truncate">
                                          {name}
                                       </div>
                                       <div className="text-xs text-gray-500 truncate">
                                          {description || 'No description'}
                                       </div>
                                    </div>
                                 </div>
                              </>
                           })
                        }
                     </div>
                  }
               },
               {
                  field: 'description',
                  caption: 'Description',
                  render: description => <div className="text-xs text-gray-600 max-w-[400px]">
                     {description}
                  </div>
               },
               {
                  field: 'installable',
                  caption: 'Installable',
                  render: installable => installable ? 'Yes' : 'No'
               },
               {
                  field: 'actions',
                  caption: '',
                  render: (_, product) => <>
                     <IconButton size="small" onClick={() => this.openEditor(product)}>
                        <EditIcon fontSize="small" />
                     </IconButton>
                     <IconButton size="small" onClick={() => this.deleteProduct(product)} color="error">
                        <DeleteIcon fontSize="small" />
                     </IconButton>
                     {
                        !product.quickbooks_id && <IconButton
                           onClick={() => this.openConnectToQuickbooksModal(product)}
                           size="small"
                           title="Connect to Quickbooks"
                        >
                           <Link fontSize="small" />
                        </IconButton>
                     }
                  </>
               }
            ]}
            rows={this.state.products}
            fullHeight
            pagination={{
               page: this.state.page,
               count: this.state.productCount,
               labelRowsPerPage: "Products per page",
               rowsPerPage: this.state.pageSize,
               onPageChange: async (_, page) => {
                  await this.updateState({ page });
                  this.fetchProducts();
               },
               onRowsPerPageChange: async (event) => {
                  await this.updateState({ page: 0, pageSize: event.target.value });
                  this.fetchProducts();
               }
            }}
            onRefresh={this.fetchProducts}
            onAdd={onAdd}
         />
         {
            this.state.editorOpen && <Editor
               onClose={this.closeEditor}
               productBeingEdited={this.state.selectedProduct}
            />
         }
         {
            this.state.connectQuickbooksModalOpen && <ConnectEntityToQuickbooks
               title={`Connect "${this.state.selectedProduct.name}" to Quickbooks`}
               quickbooksIdKey="quickbooks_id"
               submitUrl={"/api/general/quickbooks/product-connection"}
               fetchData={async () => {
                  const res = await request.get("/api/general/quickbooks/products");
                  return res.data.products;
               }}
               entityKey="product"
               entityId={this.state.selectedProduct._id}
               extraFields={[
                  {
                     name: 'quantity_on_hand',
                     label: 'Quantity on hand',
                     type: 'number',
                     required: true,
                  },
                  {
                     name: 'purchase_cost',
                     label: 'Purchase cost',
                     type: 'number',
                     required: true,
                  },
                  {
                     name: 'inventory_start_date',
                     label: 'Inventory start date',
                     type: 'date',
                     required: true,
                  }
               ]}
               renderOption={(props, option) => {
                  return <li {...props} className="border-b last:border-none cursor-pointer hover:bg-gray-100">
                     <div className='px-4 py-2'>
                        {option.name}
                     </div>
                  </li>
               }}
               onClose={this.closeConnectToQuickbooksModal}
            />
         }
      </>
   }
}


const mapStateToProps = state => ({ roles: state.user.roles });
const Products = connect(mapStateToProps)(_Products);

export default Products;